const lastAppIdByEl = new WeakMap<Element, string>();

/** Minimal hook view API used by panel loaders (avoids `Hook<{}>` missing `el` in types). */
type PanelLoadHookView = {
  el: HTMLElement;
  pushEvent(event: string, payload: Record<string, string>): void;
};

/**
 * Pushes a panel load event when `data-app-id` is set or changes. Skips duplicate pushes
 * for the same id on redundant `updated()` calls.
 */
export function pushPanelLoadEvent(
  hook: PanelLoadHookView,
  eventName: string
): void {
  const appId = hook.el.getAttribute('data-app-id');
  if (!appId) return;
  if (lastAppIdByEl.get(hook.el) === appId) return;
  lastAppIdByEl.set(hook.el, appId);
  hook.pushEvent(eventName, { app_id: appId });
}
